import type { AssetsBalanceGroup } from '@/components/dashboard/useGroupedBalances/useGroupedBalances'

export const assetsBalanceMock: AssetsBalanceGroup = [
  {
    groupName: 'ETH',
    groupTotalBalance: 5400,
    balances: [
      {
        address: '0x0000000000000000000000000000000000000000',
        assetCaip: 'eip155:8453/slip44:60',
        assetGroup: 'ETH',
        name: 'Ether',
        decimals: 18,
        network: {
          name: 'base',
          chainId: 8453,
          networkCaip: 'eip155:8453',
        },
        symbol: 'ETH',
        balanceUsd: 3000,
        balanceNative: 1000000000000000000n,
      },
      {
        address: '0x0000000000000000000000000000000000000000',
        assetCaip: 'eip155:8453/slip44:60',
        assetGroup: 'ETH',
        name: 'Ether',
        decimals: 18,
        network: {
          name: 'mainnet',
          chainId: 1,
          networkCaip: 'eip155:1',
        },
        symbol: 'ETH',
        balanceUsd: 2400,
        balanceNative: 800000000000000000n,
      },
    ],
  },
  {
    groupName: 'USDC',
    balances: [
      {
        address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        assetCaip: 'eip155:8453/erc20:0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        assetGroup: 'USD',
        name: 'USD Coin',
        decimals: 6,
        network: {
          name: 'base',
          chainId: 8453,
          networkCaip: 'eip155:8453',
        },
        symbol: 'USDC',
        balanceUsd: 2000,
        balanceNative: 2000000000n,
      },
      {
        address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
        assetCaip: 'eip155:8453/erc20:0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        assetGroup: 'USD',
        name: 'USD Coin',
        decimals: 6,
        network: {
          name: 'mainnet',
          chainId: 1,
          networkCaip: 'eip155:1',
        },
        balanceUsd: 2000,
        balanceNative: 2000000000n,
        symbol: 'USDC',
      },
    ],
    groupTotalBalance: 4000,
  },
]
